export function Avatar({
  name,
  url,
  size = 44,
  status,
}: {
  readonly name: string;
  readonly url?: string | null;
  readonly size?: number;
  readonly status?: "online" | "offline";
}) {
  const hue = hashHue(name);
  return (
    <span className="avatar" style={{
      width: size,
      height: size,
      background: `linear-gradient(145deg, hsl(${hue} 64% 62%), hsl(${(hue + 35) % 360} 62% 44%))`,
      fontSize: Math.max(12, size * 0.34),
    }} aria-label={name}>
      {url === null || url === undefined ? initials(name) : <img src={url} alt="" />}
      {status === undefined ? null : <i className={`presence ${status}`} />}
    </span>
  );
}

function initials(name: string): string {
  const value = name.trim();
  if (value.length === 0) return "?";
  const parts = value.split(/\s+/u);
  return parts.length > 1
    ? `${parts[0]?.[0] ?? ""}${parts[1]?.[0] ?? ""}`.toUpperCase()
    : Array.from(
        new Intl.Segmenter("zh-CN", { granularity: "grapheme" }).segment(value),
        (segment) => segment.segment,
      ).slice(0, 2).join("").toUpperCase();
}

function hashHue(value: string): number {
  let hash = 0;
  for (const character of value) {
    const codePoint = character.codePointAt(0);
    if (codePoint !== undefined) hash = (hash * 31 + codePoint) >>> 0;
  }
  return hash % 360;
}
